/**
 * EU Compliance Form
 * Simple standalone form (name, email, phone, order number) with reCAPTCHA Enterprise.
 * Captcha logic mirrors assets/dynamic-form.js.
 */
function initEuComplianceForm(config, form, sectionId) {
	if (!form) return;

	const submitBtn = form.querySelector("#formsubmit");
	const feedbackEl = form.querySelector(`#eu-form-feedback-${sectionId}`);
	let feedbackTimeout = null;
	let gRecaptchaWidget = null;

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		hideFeedback();
		setLoading(true);

		if (!validateForm()) {
			setLoading(false);
			return;
		}

		// If the honeypot field has a value it's a spam bot
		const honeypot = form.querySelector('input[name="companyName2"]');
		if (honeypot && honeypot.value) {
			setLoading(false);
			return;
		}

		await submitForm();
	});

	function validateForm() {
		// Native validation for required fields (name, email, phone, type, order number)
		if (!form.checkValidity()) {
			form.reportValidity();
			return false;
		}
		// reCAPTCHA check
		if (
			typeof grecaptcha === "undefined" ||
			!grecaptcha.enterprise ||
			grecaptcha.enterprise.getResponse(gRecaptchaWidget) === ""
		) {
			showFeedback("Please check the reCaptcha", "error");
			return false;
		}
		return true;
	}

	async function submitForm() {
		const recaptchaResponse = grecaptcha.enterprise.getResponse(gRecaptchaWidget);

		// Payload: field values are dynamic, the rest are hardcoded
		const payload = {
			name: form.querySelector("#name").value,
			email: form.querySelector("#email").value,
			phone_mobile: form.querySelector("#phone_mobile").value,
			subject: "New EU Compliance Submission",
			description: "",
			order_number: form.querySelector("#order_number").value,
			type: "Cancel Request",
			subtype: form.querySelector("#request_type").value,
			business_unit: "Hotel Collection",
			page_origin: "EuCompliance",
			"g-recaptcha-response": recaptchaResponse,
		};

		const url = config.use_test_url ? config.test_url : config.production_url;

		if (!url) {
			console.error("EU Compliance Form: submission URL is not configured.");
			showFeedback("Something went wrong. Please try again later.", "error");
			setLoading(false);
			return;
		}

		const requestOptions = {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		};

		try {
			const response = await fetch(url, requestOptions);
			let data = {};
			try {
				data = await response.json();
			} catch (parseErr) {
				data = {};
			}

			setLoading(false);
			grecaptcha.enterprise.reset(gRecaptchaWidget);

			const isSuccess =
				response.ok &&
				(data.status === "success" || data.success === true || data.status === undefined);

			if (isSuccess) {
				form.reset();
				showFeedback("Thank you! Your submission has been received.", "success");
			} else {
				showFeedback(data.message || "Something went wrong. Please try again.", "error");
			}
		} catch (error) {
			console.error(error);
			setLoading(false);
			if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
				grecaptcha.enterprise.reset(gRecaptchaWidget);
			}
			showFeedback("Something went wrong. Please try again.", "error");
		}
	}

	function showFeedback(message, type) {
		if (!feedbackEl) return;
		if (feedbackTimeout) clearTimeout(feedbackTimeout);
		feedbackEl.textContent = message;
		feedbackEl.classList.remove("is-success", "is-error");
		feedbackEl.classList.add("is-visible", type === "success" ? "is-success" : "is-error");
		// Auto-hide after a few seconds
		feedbackTimeout = setTimeout(hideFeedback, 6000);
	}

	function hideFeedback() {
		if (!feedbackEl) return;
		if (feedbackTimeout) clearTimeout(feedbackTimeout);
		feedbackEl.classList.remove("is-visible", "is-success", "is-error");
		feedbackEl.textContent = "";
	}

	function setLoading(status) {
		if (!submitBtn) return;
		if (status) {
			submitBtn.classList.add("loading");
			submitBtn.disabled = true;
		} else {
			submitBtn.classList.remove("loading");
			submitBtn.disabled = false;
		}
	}

	// reCAPTCHA Enterprise widget rendering (logic from assets/dynamic-form.js)
	const handleRecaptchaAvailability = () => {
		if (
			typeof grecaptcha !== "undefined" &&
			grecaptcha.enterprise &&
			typeof grecaptcha.enterprise.render === "function"
		) {
			recaptchaObserver.disconnect();
			if (gRecaptchaWidget === null) {
				gRecaptchaWidget = grecaptcha.enterprise.render(`recaptcha_${sectionId}`, {
					sitekey: "6LfeJyUqAAAAAPkVgk_VuyW6b52woueyz4seDRCt",
				});
			}
		}
	};

	const recaptchaObserver = new MutationObserver(handleRecaptchaAvailability);
	recaptchaObserver.observe(document.body, {
		childList: true,
		subtree: true,
	});
	handleRecaptchaAvailability();
}
